var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-radio',_vm._b({class:[
    'radio-' + _vm.radioSize,
    {'full-width': _vm.isFullWidth}
  ],on:{"focus":function($event){return _vm.$emit('focus')},"blur":function($event){return _vm.$emit('blur')},"clear":function($event){return _vm.$emit('clear')},"input":function($event){return _vm.$emit('input')}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'el-radio',_vm.trimAttrs(_vm.$attrs),false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }